window.facetsMostradosInicialmente = 5;

// Show-hide Mobile filters
$("#sidebar-toogle").click(function () {
    $(".sidebar-filters").addClass("sidebar-filters--unfolded");
    $("body").addClass("filters-open");
});
$(".sidebar-filters-overlay, .sidebar-filters-close").click(function () {
    $(".sidebar-filters").removeClass("sidebar-filters--unfolded");
    $("body").removeClass("filters-open");
});

/*****************/
/****** ADD ******/
/*****************/

/**
 * Add facet to the selected facets filter to show the table of elements
 *
 * @param   {string}    facet           The facet name to add
 * @param   {string}    value           The facet value to add
 * @param   {function}  callback        The function to call for load new page
 * @param   {string}    selectorId      The selector to slide
 */
window.addSelectedFacet = function (
    facet      = '',
    value      = '',
    callback   = function () {
    },
    selectorId = ''
) {
    setCurrentParam(facet, value, false);
    // addStoredSelectedFacet(facet, value);
    // if (facet === 'campana_nombre_string') {
    //     $('#subCatalogos a').removeClass('active');
    //     $(`#subCatalogos a[data-value="${value}"]`).addClass('active');
    // } else {
    fillSelectedFacet(facet, value, callback, selectorId);
    // }
    // Recargamos el listado
    loadPage(1, callback, selectorId);
};

/**
 * Add facet to the stored selected facets filter to show the table of elements
 *
 * @param      {string}  facet  The facet name to add
 * @param      {string}  value  The facet value to add
 */
// window.addStoredSelectedFacet = function (facet = '', value = '') {
//     let storedSelectedFacets = getStorage('selectedFacets');
//     if ($.isEmptyObject(storedSelectedFacets) || storedSelectedFacets.length === 0) {
//         // Si no tengo filtro en caché lo creo con la nueva faceta filtrada
//         let selectedFacets    = {};
//         selectedFacets[facet] = value;
//         setStorage('selectedFacets', JSON.stringify(selectedFacets));
//     } else {
//         // Si tengo filtro en caché, añado la nueva faceta filtrada
//         storedSelectedFacets = JSON.parse(storedSelectedFacets);
//         if ('undefined' === typeof storedSelectedFacets[facet]) {
//             storedSelectedFacets[facet] = value;
//         } else {
//             if (!(storedSelectedFacets[facet] instanceof Object)) {
//                 if (storedSelectedFacets[facet] !== value) {
//                     storedSelectedFacets[facet] = [
//                         storedSelectedFacets[facet],
//                         value,
//                     ];
//                 }
//             } else {
//                 let founded = false;
//                 storedSelectedFacets[facet].forEach((storedSelectedFacetValue) => {
//                     if (storedSelectedFacetValue === value) {
//                         founded = true;
//                     }
//                 });
//                 if (!founded) {
//                     storedSelectedFacets[facet].push(value);
//                 }
//             }
//         }
//
//         setStorage('selectedFacets', JSON.stringify(storedSelectedFacets));
//     }
// };

/***************************/
/****** FILL SELECTED ******/
/***************************/

/**
 * Loads stored selected facets filter
 *
 * @param   {function}  callback        The function to call for load new page
 * @param   {string}    selectorId      The selector to slide
 */
window.loadSelectedFacets = function (
    callback   = function () {
    },
    selectorId = ''
) {
    // Loop over the received facetsFilter
    let searchParams = new URLSearchParams(window.location.search);
    if (!$.isEmptyObject(searchParams) && searchParams.length !== 0) {
        // Rellenamos el contenedor de facetas seleccionadas
        searchParams.forEach((storedSelectedValue, storedSelectedFacet) => {
            if (storedSelectedFacet !== 'pagina' && storedSelectedFacet !== 'buscador' && storedSelectedFacet !== 'orderBy' && storedSelectedFacet !== 'orderDir' && storedSelectedFacet !== 'nivel_campana' && !storedSelectedFacet.startsWith('conditions')) {
                let storedSelectedValues = searchParams.getAll(storedSelectedFacet);
                if (storedSelectedValues.length > 1) {
                    storedSelectedValues.forEach(function (storedSelectedValue, index) {
                        fillSelectedFacet(storedSelectedFacet, storedSelectedValue, callback, selectorId);
                    });
                } else {
                    fillSelectedFacet(storedSelectedFacet, storedSelectedValue, callback, selectorId);
                }
            }
        });
    }

    // let storedSelectedFacets = getStorage('selectedFacets');
    // if (!$.isEmptyObject(storedSelectedFacets) && storedSelectedFacets.length !== 0) {
    //     // Si tengo filtro en caché lo cargo
    //     storedSelectedFacets = JSON.parse(storedSelectedFacets);
    //     // Rellenamos el contenedor de facetas seleccionadas
    //     // Loop over the received storedSelectedFacets
    //     for (let storedFacet in storedSelectedFacets) {
    //         if (!(storedSelectedFacets[storedFacet] instanceof Object)) {
    //             fillSelectedFacet(storedFacet, storedSelectedFacets[storedFacet], callback, selectorId);
    //         } else {
    //             for (let storedFacetValueIterator in storedSelectedFacets[storedFacet]) {
    //                 fillSelectedFacet(storedFacet, storedSelectedFacets[storedFacet][storedFacetValueIterator], callback, selectorId);
    //             }
    //         }
    //     }
    // }
};

/**
 * Fill the facets selected
 *
 * @param   {string}    facet           The facet filter to fill
 * @param   {string}    value           The facet value where fill
 * @param   {function}  callback        The function to call for load new page
 * @param   {string}    selectorId      The selector to slide
 */
function fillSelectedFacet(
    facet      = '',
    value      = '',
    callback   = function () {
    },
    selectorId = ''
) {
    // Compruebo que no venga nada vacio
    if (
        facet &&
        0 !== facet.length &&
        value &&
        0 !== value.length &&
        0 === $(`#sidebar-filters-selected li[data-facet="${facet}:${value}"]`).length
    ) {
        // Mostramos el contenedor de facetas seleccionadas
        $('#sidebar-filters-selected').show();
        // Añadimos el filtro seleccionado al facetSelected
        let auxFacet = `<li data-facet="${facet}:${value}">
                                    <a href="javascript:void(0);" onClick="removeSelectedFacet('${facet}', '${value.replace(/'/g, "\\'")}', '${callback}', '${selectorId}');">`;
        if (facet !== 'atributo_valor2') {
            auxFacet += `${ucfirst(transBusquedaCampos[facet])}: <small>${transformFacetValue(facet, value.replace(/'/g, "\\'"))}</small>`;
        } else {
            let atributo_valor_local = transformDynamicFacetValue(value);
            auxFacet += `${atributo_valor_local.atributo}: <small>${atributo_valor_local.valor}</small>`;
        }
        auxFacet += `</a>
                </li>`;
        $('#sidebar-filters-selected ul').append(auxFacet);
    }
}

/******************/
/****** FILL ******/
/******************/

/**
 * Fitro para cabeceras de los filtros
 * @param selectorId
 */
const filtroDeCabeceras = (selectorId = '') => {

    if ($('.filter-search input').length > 0) {
        $('.filter-search input').val('');
        return;
    }

    const html = `
    <div class="filter-search">
        <i class="ri-search-line"></i>
        <input type="text" class="form-control" name="buscador" id="" placeholder="${ucfirst(transFiltroFacetas)}" oninput="fitrarCabeceras(event)">
    </div>
   `;

    $(selectorId).append(html);

    // Sobreescribo la función contains de jQuery para que sea case insensitive
    jQuery.expr[':'].contains = function (a, i, m) {
        return jQuery(a).text().toUpperCase()
                        .indexOf(m[3].toUpperCase()) >= 0;
    };

    //Función Buscar en Menu Lateral Izq
    window.fitrarCabeceras = function (evt) {
        const value = evt.target.value;
        if (value.length > 0) {
            // oculto todos los elementos
            $('.facetList').hide();
            // muestro solo los elementos que contienen el valor del input
            $(`.sidebar-title:contains(${value})`).closest('.facetList').show();
        } else {
            // muestro todos los elementos
            $('.facetList').show();
        }
    };

}
/**
 * Fill the facets list
 *
 * @param   {array}     facets      The facets to fill
 * @param   {function}  callback    The function to call for load new page
 * @param   {string}    selectorId  The selector to slide
 */
window.fillFacets = function (
    facets     = [],
    callback   = function () {
    },
    selectorId = ''
) {
    $('.facetList').remove();
    // Compruebo que no venga nada vacío
    if (!$.isEmptyObject(facets)) {
        filtroDeCabeceras('.sidebar-filters-column-wrapper');
        // Loop over the received facets
        for (let facet in facets) {
            let facetList = '';
            switch (typeof facets[facet]) {
                case 'number': // Facet Query
                    if (facets[facet] !== 0) {
                        facetList = `<div class="sidebar-block facetList">
                                        <div class="sidebar-title">${transBusquedaCampos[facet]}</div>
                                        <div class="sidebar-block-body">
                                            <ul>
                                                <li>
                                                    <a href="javascript:void(0);" onclick="addSelectedFacet('${facet}', '${value}', '${callback}', ${selectorId});">${value} <span>${facets[facet][value]}</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>`;
                    }
                    break;
                case 'object': // Facet Field, Facet MultiQuery
                    // Si la faceta no tiene valores o si solo tiene un valor cuyo identificador esta vacío, es decir, no tiene nada asignado
                    if (
                        typeof facets[facet] === 'object' &&
                        !$.isEmptyObject(facets[facet]) &&
                        !(
                            Object.keys(facets[facet]).length === 1 &&
                            Object.keys(facets[facet])[0].length === 0
                        )
                    ) {
                        if (facet !== 'atributo_valor2') {
                            let facetListDropdown = '';
                            let total             = 0;

                            if (facet === 'ano_edicion') {
                                const data = {...facets[facet]};
                                delete data["0"];
                                facets[facet] = Object.entries(data).sort(([yearA], [yearB]) => Number(yearB) - Number(yearA));
                            }

                            // Loop over the received facets
                            for (let value in facets[facet]) {
                                let facetValue = value;
                                let facetCount = facets[facet][value];

                                if (facet === 'ano_edicion') {
                                    facetValue = facets[facet][value][0];
                                    facetCount = facets[facet][value][1];
                                }

                                if (facetCount) {
                                    let auxFacet = `<li>
                                                                <a href="javascript:void(0);" onclick="addSelectedFacet('${facet}', '${facetValue}', '${callback}', ${selectorId});">
                                                                    ${transformFacetValue(facet, facetValue)}
                                                                    <span>${facetCount}</span>
                                                                </a>
                                                            </li>`;
                                    total++;
                                    if (total <= facetsMostradosInicialmente) {
                                        facetList += auxFacet;
                                    } else {
                                        facetListDropdown += auxFacet;
                                    }
                                }
                            }
                            if (total) {
                                facetList = `<div class="sidebar-block facetList">
                                                <div class="sidebar-title">${transBusquedaCampos[facet]}</div>
                                                <div class="sidebar-block-body">
                                                    <ul>
                                                        ${facetList}
                                                    </ul>
                                                    ${facetListDropdown.length ?
                                                      `<div class="collapse" id="facetCollapse${facet.replace(/ /g, "_")}">
                                                            <ul class="facet-group">
                                                                ${facetListDropdown}
                                                            </ul>
                                                      </div>
                                                      <a type="button" class="facet-toggle facet-toggle-more" data-bs-toggle="collapse" href="#facetCollapse${facet.replace(/ /g, "_")}" onclick="$(this).attr('aria-expanded') === 'true' ? $(this).text(transBusquedaVerMenos + ' -') : $(this).text(transBusquedaVerMas + ' +')" aria-expanded="false" aria-controls="facetCollapse${facet}">${transBusquedaVerMas} +</a>` : ''}
                                                </div>
                                            </div>`;
                                // Append the facet HTML
                                $(`.sidebar-filters-column-wrapper`).append(facetList);
                            }
                        } else if (facet === 'atributo_valor2') {
                            fillDynamicFacets(facets[facet], callback, selectorId);
                        }
                    }
                    break;
            }
        }
    }
}


/**
 * Fill the dynamic facet list
 *
 * @param   {array}     values      The facet values for dynamic facet
 * @param   {function}  callback    The function to call for load new page
 * @param   {string}    selectorId  The selector to slide
 */
function fillDynamicFacets(
    values,
    callback   = function () {
    },
    selectorId = ''
) {
    let atributo_valor_local = agruparPorAtributo(parseAtributoValor(values));

    $.each(atributo_valor_local, function (index, facet) {
        let facetList         = '';
        let facetListDropdown = '';
        let total             = 0;
        if (facet[0].atributo !== 'texto corto') {
            $.each(facet, function (indey, value) {
                let auxFacet = `<li>
                                  <a href="javascript:void(0);" onclick="addSelectedFacet('atributo_valor2', '${value.original.replace(/'/g, "\\'")}', '${callback}', ${selectorId});">${value.valor} <span>${value.cantidad}</span></a>
                                    </li>`;
                total++;
                if (total <= facetsMostradosInicialmente) {
                    facetList += auxFacet;
                } else {
                    facetListDropdown += auxFacet;
                }
            });
            facetList = `<div class="sidebar-block facetList">
                        <div class="sidebar-title">${facet[0].atributo}</div>
                        <div class="sidebar-block-body">
                            <ul>
                                ${facetList}
                            </ul>
                            ${facetListDropdown.length ?
                              `<div class="collapse" id="facetCollapse${facet[0].atributo.replace(/ /g, "_")}">
                                    <ul class="facet-group">
                                        ${facetListDropdown}
                                    </ul>
                              </div>
                              <a type="button" class="facet-toggle facet-toggle-more" data-bs-toggle="collapse" href="#facetCollapse${facet[0].atributo.replace(/ /g, "_")}" onclick="$(this).attr('aria-expanded') === 'true' ? $(this).text(transBusquedaVerMenos + ' -') : $(this).text(transBusquedaVerMas + ' +')" aria-expanded="false" aria-controls="facetCollapse${facet[0].atributo}">${transBusquedaVerMas} +</a>` : ''}
                        </div>
                    </div>`;

            // Append the product HTML
            $(`.sidebar-filters-column-wrapper`).append(facetList);
        }
    })

}

/*******************/
/****** CLEAN ******/
/*******************/

/**
 * Clean selected facets filter
 *
 * @param   {function}  callback    The function to call for load new page
 * @param   {string}    selectorId  The selector to slide
 */
window.cleanSelectedFacets = function (
    callback   = function () {
    },
    selectorId = ''
) {
    cleanStoredSelectedFacets();
    // Vaciamos y ocultamos el contenedor de facetas seleccionadas
    $('#sidebar-filters-selected').hide().find('ul').empty();
    // Recargamos el listado
    loadPage(1, callback, selectorId);
};

/**
 * Clean stored selected facets filter
 */
window.cleanStoredSelectedFacets = function () {
    // Loop over the received facetsFilter
    let searchParams = new URLSearchParams(window.location.search);
    if (!$.isEmptyObject(searchParams) && searchParams.length !== 0) {
        // @Disclaimer: URLSearchParams.forEach parece estar roto en la última versión, se salta el primer valor!
        const searchParamsAux = Array.from(searchParams);
        for (const element of searchParamsAux) {
            const [facet, value] = element;
            if (facet !== 'pagina' && facet !== 'buscador' && facet !== 'orderBy' && facet !== 'orderDir') {
                searchParams.delete(facet);
            }
        }
    }

    // Construir la URL actualizada con los parámetros
    // let updatedURL = url.split('?')[0] + '?' + searchParams.toString();

    // Actualizar la URL en el historial del navegador sin recargar la página
    // window.history.pushState({path: updatedURL}, '', updatedURL);

    history.replaceState({}, "", `?${searchParams.toString()}`);

    // setStorage('selectedFacets', '');
};

/********************/
/****** REMOVE ******/
/********************/

/**
 * Remove facet from the selected facets filtar to show the table of elements
 *
 * @param   {string}    facet           The facet name to remove
 * @param   {string}    value           The facet value to remove
 * @param   {function}  callback        The function to call for load new page
 * @param   {string}    selectorId      The selector to slide
 */
window.removeSelectedFacet = function (
    facet      = '',
    value      = '',
    callback   = function () {
    },
    selectorId = ''
) {
    deleteCurrentParam(facet, value);
    // removeStoredSelectedFacet(facet, value);
    unfillSelectedFacet(facet, value);
    // Recargamos el listado
    loadPage(1, callback, selectorId);
};

/**
 * Remove facet from the stored selected facets filter to not show the table of elements
 *
 * @param      {string}  facet  The facet name to add
 * @param      {string}  value  The facet value to add
 */
// window.removeStoredSelectedFacet = function (facet, value) {
//     let storedSelectedFacets = getStorage('selectedFacets');
//     if (!$.isEmptyObject(storedSelectedFacets) && storedSelectedFacets.length > 0) {
//         // Si tengo filtro en caché, borro la faceta filtrada
//         storedSelectedFacets = JSON.parse(storedSelectedFacets);
//         delete storedSelectedFacets[facet];
//         if ($.isEmptyObject(storedSelectedFacets)) {
//             setStorage('selectedFacets', '');
//         } else {
//             setStorage('selectedFacets', JSON.stringify(storedSelectedFacets));
//         }
//     }
// }

/**
 * Unfill the facets selected
 *
 * @param   {string}    facet           The facet filter to fill
 * @param   {string}    value           The facet value where fill
 */
window.unfillSelectedFacet = function (facet, value) {
    if (facet && facet.length !== 0 && value && value.length !== 0) {
        $(`#sidebar-filters-selected li[data-facet="${facet}:${value}"]`).remove();
        // Ocultamos el contenedor de facetas seleccionadas si ya no hay más facetas seleccionadas
        if ($(`#sidebar-filters-selected li[data-facet]`).length === 0) {
            $("#sidebar-filters-selected").hide();
        }
    }
}
